<div class="offer-overlay" id="offerOverlay" *ngIf="(dailyOfferState.showOffer$ | async)">
  <div class="offer-modal">

    <button class="offer-close" (click)="close()" aria-label="Close">✕</button>

    <!-- HEADER -->
    <div class="offer-header">
      <div class="offer-badge">
        {{ "saveupto" | transloco }}
        <span>50%</span>
      </div>

      <h2 class="offer-title">
        {{ "saveuptotext" | transloco }}
      </h2>

      <div class="offer-timer" [class.alert-error-text]="(dailyOfferState.progress$ | async)! <= 80">
        {{ dailyOfferState.timer$ | async }}
      </div>

      <div class="offer-progress-wrap">
        <div class="offer-progress-bar" [style.width.%]="dailyOfferState.progress$ | async"
          [class.danger]="(dailyOfferState.progress$ | async)! <= 80">
        </div>
      </div>
    </div>

    <!-- BODY -->
    <div class="offer-body">

      <div class="offer-products">
        <div class="offer-product-card" *ngFor="let element of brandOfferProducts">

          <div class="offer-product-image" (click)="productDetails(element)">
            <img class="pointer" [src]="fixImage(element.image)" alt="product" />
          </div>

          <div class="offer-product-content">
            <div class="offer-product-top">
              @if(isAr){
              <h3 class="offer-product-name">{{ element.name_ar }}</h3>
              } @else {
              <h3 class="offer-product-name">{{ element.name_en }}</h3>
              }
            </div>

            <div class="offer-price-row">
              <span class="offer-new-price">
                {{element.affiliationprice}} {{ "egpe" | transloco }}
              </span>

              @if(calcDis(element.affiliationprice,element.priced) != 0){
              <span class="offer-old-price">
                {{element.priced}} {{ "egpe" | transloco }}
              </span>
              }
            </div>

            <button class="offer-add-btn" [class.alert-error]="(dailyOfferState.progress$ | async)! <= 80"
              (click)="addToCart(element, $event)">
              {{ "addtocart" | transloco }}
            </button>
          </div>
        </div>
      </div>

      <button type="button" class="offer-more-btn" (click)="goToDailyOffers()">
        {{ "See More" | transloco }}
      </button>
    </div>
  </div>
</div>

<!-- Floating Offer Chip -->
<div class="offer-float-chip" *ngIf="!(dailyOfferState.showOffer$ | async) && showFloatingChip" (click)="reopen()">

  <div class="offer-float-dot"></div>

  <div class="offer-float-content">
    <span class="offer-float-label">{{ "saveupto" | transloco }}</span>
    <span class="offer-float-timer">{{ dailyOfferState.timer$ | async }}</span>
  </div>
</div>
